import { Drawer, Loading } from '@/components';
import {
  useProject,
  useUpdateProjectOtherNotes,
} from '@/features/project/_hooks/project';
import { useId } from '@/hooks';
import { useMessage } from '@/providers';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useProjectDetailDrawerState } from '../../../_components/ProjectDrawerStateProvider';
import { ProjectOtherNotesForm } from './ProjectOtherNotesForm';

export const ProjectOtherNotesFormDrawer: FC = () => {
  const { t } = useTranslation();
  const { id: projectId } = useId();
  const project = useProject(projectId);

  const { openMessage } = useMessage();
  const { drawerState, setDrawerState } = useProjectDetailDrawerState();
  const { mutateAsync: updateProjectOtherNotesAsync } =
    useUpdateProjectOtherNotes();

  if (project.isPending || !project.data) {
    return <Loading />;
  }

  const handleClose = async () => {
    setDrawerState({ open: false });
  };

  return (
    <Drawer
      open={drawerState.open && drawerState.type === 'other-notes'}
      onClose={handleClose}
      destroyOnClose
    >
      <ProjectOtherNotesForm
        onSubmit={async (values) => {
          await updateProjectOtherNotesAsync({
            ...values,
            id: projectId,
          });
          await Promise.all([
            openMessage('success', t('message-update-completed')),
            handleClose(),
          ]);
        }}
        initialValues={{ otherSpecialNotes: project.data.otherSpecialNotes }}
      />
    </Drawer>
  );
};
